import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AssetsDisable from 'components/assets/disable';

import { setEnableAssetModalIsOpened, enableAsset } from 'containers/assets/actions';
import { addGrowlMessage as addMsg } from 'messages/actions';

import { getCompany, getSubcompany } from 'auth/selectors';
import { getEnableModalIsOpened, getSelectedAsset } from 'selectors/assets';

class AssetsEnableModalContainer extends Component {
  static propTypes = {
    asset: PropTypes.object,
    company: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    isOpened: PropTypes.bool.isRequired,
    seIsOpened: PropTypes.func.isRequired,
    subcompany: PropTypes.object.isRequired,
  };

  handleClose = () => {
    this.props.seIsOpened(false);
  };

  handleAccept = () => {
    this.props
      .enableAsset(this.props.asset.id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => {
        this.props.seIsOpened(false);
        this.props.fetch();
        this.props.addMsg(value.message, 'success', 'common.success');
      })
      .catch((err) => {
        this.props.seIsOpened(false);
        this.props.fetch();
        this.props.addMsg(err.message, 'danger', 'common.error');
      });
  };

  render = () => (
    <AssetsDisable.EnableModal
      asset={this.props.asset}
      handleClose={this.handleClose}
      handleAccept={this.handleAccept}
      isOpened={this.props.isOpened}
    />
  );
}

const mapStateToProps = (state) => ({
  asset: getSelectedAsset(state),
  company: getCompany(state),
  isOpened: getEnableModalIsOpened(state),
  subcompany: getSubcompany(state),
});
const mapDispatchToProps = {
  addMsg,
  enableAsset,
  seIsOpened: setEnableAssetModalIsOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetsEnableModalContainer);



// WEBPACK FOOTER //
// src/containers/assets/AssetsEnableModalContianer.js